import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=967ef28a"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports